import PageLoader, { PAGE_LOADER_TEST_ID } from './PageLoader';

export { PAGE_LOADER_TEST_ID };
export default PageLoader;
